import React from "react"
import styled from "styled-components"

const StyledSpinnerBlock = styled.div`
    width: 33%;
    height: 33%;
    float: left;
    @-webkit-keyframes sk-cubeGridScaleDelay {
        0%,
        70%,
        100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        }
        35% {
            -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1);
        }
    }

    @keyframes sk-cubeGridScaleDelay {
        0%,
        70%,
        100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        }
        35% {
            -webkit-transform: scale3D(0, 0, 1);
            transform: scale3D(0, 0, 1);
        }
    }
    -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    &:nth-child(1) {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
    }
    &:nth-child(2) {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
    }
    &:nth-child(3) {
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s;
    }
    &:nth-child(4) {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
    }
    &:nth-child(5) {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
    }
    &:nth-child(6) {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
    }
    &:nth-child(7) {
        -webkit-animation-delay: 0s;
        animation-delay: 0s;
    }
    &:nth-child(8) {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
    }
    &:nth-child(9) {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
    }
`

const StyledSpinnerWrapper = styled.div`
    display: ${(props) => (props.isShown ? "block" : "none")};
    height: ${(props) =>
        (props.size === "xs" && "0.6rem") ||
        (props.size === "small" && "1rem") ||
        (props.size === "medium" && "1.5rem") ||
        (props.size === "large" && "2.2rem")};
    width: ${(props) =>
        (props.size === "xs" && "0.6rem") ||
        (props.size === "small" && "1rem") ||
        (props.size === "medium" && "1.5rem") ||
        (props.size === "large" && "2.2rem")};
    ${StyledSpinnerBlock} {
        background-color: ${(props) => props.color || props.theme.color.white};
    }
`

const KCSpinner = ({ color, isShown = false, size = "medium" }) => {
    return (
        <StyledSpinnerWrapper color={color} isShown={isShown} size={size}>
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
            <StyledSpinnerBlock />
        </StyledSpinnerWrapper>
    )
}

export default KCSpinner
